// import api from "../../../../../api";
// import React from "react";
// import values from "../../../../../values";
import { useQuery } from "react-query";
import values from "../../../../../values";
import api from "../../../../../api";
import FinancialGroupScreen from "../../../../../context/FinancialGroup.context";
import { TModal } from "../../../../../types/common.type";
import React, { useState } from "react";
import { DeleteModal } from "../../../../../components";
import utils from "../../../../../utils";
import { ICreateAndUpdateFinancialGroup } from "../../../../../types/financialGroup";
import FindGroupScreen from "..";

// import {useQuery} from "react-query";
// import {TransactionContext} from "../../../../../context";

// type TModal = "SHOW" | "NONE" | "SETUP_ORDER";

const FinancialGroupContainer = () => {
  // ** ==============================================================================================================
  // **                                         Values Validations
  // ** ==============================================================================================================

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showModal, setShowModal] = useState<TModal>("NONE");
  // const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedFinancialGroup, setSelectedFinancialGroup] = useState<any>();

  // const [selectedUserId, setSelectedUserId] = React.useState<any>(undefined);

  // !! ==============================================================================================================
  // !!                                           Start API Call
  // !! ==============================================================================================================
  // const [allTransactionFilters, setAllTransactionFilters] = React.useState<any>({
  //   page: 1,
  // });
  // const getAllTransaction = useQuery([values.useQueryKeys.getAllTransactions, allTransactionFilters], () =>
  //   api.post.common.financialFindTransaction({page: allTransactionFilters.page, limit: 20})
  // );
  // const getFileById = useQuery([values.useQueryKeys.getFileById, selectedUserId], () =>
  //   api.get.common.getFileById(selectedUserId)
  // );
  const getAllFinancilalGroup = useQuery(
    [values.useQueryKeys?.getAllFinancialGroup],
    () => api.post.administrator.getAllFinancialGroup({ limit: 10, page: 1 })
  );
  const { refetch } = getAllFinancilalGroup;

  async function deleteFunction(userId: string) {
    setIsLoading(true);
    const result = await api.dele.administrator.deleteFinancialGroup(userId);
    if (result) {
      utils.successHandler(Number(2010));
      refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }

  const updateFunction = async (
    financialGroupData: ICreateAndUpdateFinancialGroup,
    _id: string
  ) => {
    setIsLoading(true);
    const result = await api.put.administrator.updateFinancialGroup(
      financialGroupData,
      _id
    );
    if (result) {
      utils.successHandler(Number(result.CODE));
      refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  };

  const createFunction = async (
    financialGroupData: ICreateAndUpdateFinancialGroup
  ) => {
    setIsLoading(true);
    const result = await api.post.administrator.createFinancialGroup(
      financialGroupData
    );
    if (result) {
      utils.successHandler(Number(result.CODE));
      refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  };

  // !! ==============================================================================================================
  // !!                                            End API Call
  // !! ==============================================================================================================

  // ?? ==============================================================================================================
  // ??                                            JSX Container
  // ?? ==============================================================================================================

  return (
    <FinancialGroupScreen.Provider
      value={{
        getAllFinancilalGroup,
        selectedFinancialGroup,
        setSelectedFinancialGroup,
        setShowModal,
        showModal,
        updateFunction,
        createFunction,
      }}
    >
      <FindGroupScreen rqData={{ getAllFinancilalGroup }} showModalData={{}} />
      <DeleteModal
        onClose={() => setShowModal("NONE")}
        open={showModal === "DELETE"}
        loading={isLoading}
        onSubmit={deleteFunction}
        user={selectedFinancialGroup}
        data={true}
      />
    </FinancialGroupScreen.Provider>
  );
};

export default FinancialGroupContainer;
